import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { AuthService } from 'src/app/authentication/auth.service';
import { LoaderService } from '../../utils/loader.service';
import { SubmitOtpComponent } from '../machine-popups/submit-otp/submit-otp.component';
import { OnboardingService } from '../onboarding.service';

declare var $: any;

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})

export class CompanyDetailsComponent implements OnInit {

  companyDetailsForm: any;
  verifyMobileForm: any;
  phoneNumber: any;
  showExportLiscense = false;
  showAllTurnOver = false;
  showSendOtpBtn = false;
  isMobileVerified = true;
  submitted = false;
  industryTypes = ['private ltd', 'public ltd', 'llp', 'partnership', 'proprietorship', 'other']
  proprietorTitles = ['mr', 'mrs', 'miss', 'master']
  ownerInvolvements = ['0%', 'upto 50%', '100%']
  companyDetails: any;
  portfolioList: any;
  portfolioFile = [];
  ownerInvolvement;
  yearsArray = [];
  keyword = 'name';
  countries = [];
  filesData = [];
  portfolio_files_array = [];
  showFileUpload: boolean = true;
  has_verified_phone: boolean = false;
  form_status: boolean;
  default_code = "+91"
  options

  // filterOptions

  country_code;
  
  noOfEmployees=  [
  
	  {
		 "id":"1",
		 "name":"<10"
		 
	  },
	  {
		 "id":"2",
		 "name":"10-50"
		 
	  },
	  {
		 "id":"3",
		 "name":"50-100"
		 
	  },
	  {
		 "id":"4",
		 "name":"100-500"
		 
	  },
	  {
		 "id":"5",
		 "name":"500+"
		 
	  }
  ]

  constructor(
    public onboardingService: OnboardingService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    private adminService: AdminService,
    private dialog: MatDialog,
    private authService: AuthService,
  ) {

    // if (localStorage.getItem('has_onboarded') == "true") {
    //   this.router.navigate(['/onboarding/submitted']);
    // }

    // function for established year
    const currentYear = (new Date()).getFullYear();
    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));
    this.yearsArray = range(currentYear, currentYear - 120, -1);

    this.authService.getInternationalCode().subscribe(
      (res: any) => {
        res.countries.forEach(element => {
          this.countries.push(element.code)
        })

      }
    );
  }

  ngOnInit() {
    // set the companyDetailsForm

    this.companyDetailsForm = this.fb.group({
      'company_name': ["", [Validators.required, Validators.minLength(3), Validators.pattern("^[a-zA-Z0-9 _.-]+$")]],
      'website_url': ["", [Validators.required, Validators.pattern("(www)\\.([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?")]],
      'last_year_revenue': ["", [Validators.pattern("^[A-Za-z0-9]*$")]],
      'last_year_revenue_unit': "INR",
      'industry_type': ["", Validators.required],
      'established_in_year': ["", [Validators.required, Validators.min(1)]],
      'proprietor_title': ["", Validators.required],
      'proprietor_first_name': ["", [Validators.required, Validators.minLength(4), Validators.pattern('^[a-zA-Z ]*$'), Validators.maxLength(50)]],
      // 'proprietor_last_name': ["", Validators.required],
      'proprietor_email': ["", [Validators.required, Validators.email]],
      // 'phone_country_code': ["", [Validators.required, Validators.minLength(1)]],
      'contact_person_name': ["", [Validators.required, Validators.minLength(4)]],
      'contact_person_email': ["", Validators.required],
      'no_of_employees': ["", [Validators.required, Validators.min(1)]],
      'accept_batch_order': [false, Validators.required],
      'accept_export_order': [false, Validators.required],
      'working_capital_required': false,
      "gst_number": ["", [Validators.required, Validators.pattern("[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}")]],
      "pan_number": ["", [Validators.required, Validators.pattern("[A-Z]{5}[0-9]{4}[A-Z]{1}")]],
      "is_gst_registered": true,
      "current_year_revenue": ["", [Validators.pattern("^[A-Za-z0-9]*$")]],
      "current_year_revenue_unit": "INR",
      "last_to_last_year_revenue": ["", [Validators.pattern("^[A-Za-z0-9]*$")]],
      "last_to_last_year_revenue_unit": "INR",
      'export_liscense_no': ["", [Validators.pattern("^[A-Za-z0-9]*$")]],
      'portfolio': [],
      'owner_involvement': "0%",
      'address_attributes': this.fb.array([]),
      'proprietor_phone_country_code': ["", [Validators.required, Validators.minLength(1)]],
      'proprietor_phone': ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      'contact_person_title': ["", Validators.required],
      'contact_person_country_code': ["",],
      'contact_person_phone': ["", [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
    });

    this.verifyMobileForm = this.fb.group({
      'contact_no': "",
      'otp': ""
    });

    this.setCompanyDetailsForm();
    this.companyDetailsForm.controls['proprietor_phone_country_code'].setValue("91")
    this.toastr.info('Please Fill all the required fields', 'info');
    this.proprietorCountryCode("+91");
    this.contactCountryCode("+91")
  }

  proprietorCountryCode(code) {
    // let code = event.replace('+', '');
    this.companyDetailsForm.controls['proprietor_phone_country_code'].setValue(code)
  }

  contactCountryCode(code) {
    // let code = event.replace('+', '');
    this.companyDetailsForm.controls['contact_person_country_code'].setValue(code)
  }

  pro_code(event) {
    if (event != '' && !this.countries.includes(event)) {
      return this.toastr.error('Please select country code from the available options', 'Error');
    }
  }

  cp_vode(event) {
    this.pro_code(event)
  }

  workingCapital(event) {

    if (event.value == "yes") {
      console.log("true")
      this.companyDetailsForm.controls['working_capital_required'].setValue(true);
    }
    else if (event.value == "no") {
      this.companyDetailsForm.controls['working_capital_required'].setValue(false);
    }
  }

  exportOrder(event) {

    if (event.value == "yes") {
      console.log("true")
      this.companyDetailsForm.controls['accept_export_order'].setValue(true);
    }
    else if (event.value == "no") {
      this.companyDetailsForm.controls['accept_export_order'].setValue(false);
    }
  }

  batchOrder(event) {

    if (event.value == "yes") {
      console.log("true")
      this.companyDetailsForm.controls['accept_batch_order'].setValue(true);
    }
    else if (event.value == "no") {
      this.companyDetailsForm.controls['accept_batch_order'].setValue(false);
    }
  }



  createAddressGroup() {
    return this.fb.group({
      address: ["", Validators.required],
      city: ["", Validators.required],
      state: ["", Validators.required],
    })
  }

  setCompanyDetailsForm() {
    // this.loaderService.display(true);

    this.onboardingService.getCompanyDetails().subscribe(
      response => {
        let res = response["form_data"];
        console.log('Company res:', res);
        let primaryAddressDetails, factoryAddressDetails;
        var self = this;
        this.phoneNumber = res["phone_number"];
        this.companyDetails = res["company_detail"];
        this.has_verified_phone = res["has_verified_phone"]
        this.form_status = res["form_status"];
        let primaryContactPerson = res['primary_contact_person'];
        // if (this.form_status) {
        //   this.router.navigate(['/onboarding/machine-details'])
        // }
        let portfolio_attachments = res["portfolio_attachments"]
        if (portfolio_attachments) {
          if (portfolio_attachments.length > 0) {
            this.companyDetailsForm.get('portfolio').value = portfolio_attachments
            // console.log(portfolio_attachments)
          }
        }

        if (!res["has_verified_phone"]) {
          this.showSendOtpBtn = true;
          this.isMobileVerified = false;
          this.phoneNumber = "";
        }

        if (res["addresses"].length > 0) {
          res["addresses"].map(function (object) {
            self.setValueAddress(object)
          });
          let availablePrimaryAddress = false;
          let availableFactoryAddress = false;
          for (let i in res["addresses"]) {
            if (res["addresses"][i]['address_type'] == 'primary') {
              availablePrimaryAddress = true;
            }
            if (res["addresses"][i]['address_type'] == 'factory') {
              availableFactoryAddress = true;
            }
          }
          if (!availablePrimaryAddress) {
            this.initializePrimaryAddress();
          }
          if (!availableFactoryAddress) {
            this.initializeFactoryAddress();
          }
        }
        else if (res["addresses"].length == 0) {
          this.initializePrimaryAddress();
          this.initializeFactoryAddress();

        }

        this.companyDetailsForm.controls['company_name'].setValue(res['company_name']);
        if (this.companyDetails) {
          this.companyDetailsForm.controls['company_name'].setValue(this.companyDetails.company_name)
          this.companyDetailsForm.controls['website_url'].setValue(this.companyDetails.website_url)
          this.companyDetailsForm.controls['industry_type'].setValue(this.companyDetails.industry_type)
          this.companyDetailsForm.controls['established_in_year'].setValue(this.companyDetails.established_in_year)
          this.companyDetailsForm.controls['proprietor_title'].setValue(this.companyDetails.proprietor_title)
          this.companyDetailsForm.controls['proprietor_first_name'].setValue(this.companyDetails.proprietor_first_name)
          this.companyDetailsForm.controls['no_of_employees'].setValue(this.companyDetails.no_of_employees)
          this.companyDetailsForm.controls['accept_batch_order'].setValue(this.companyDetails.accept_batch_order)
          this.companyDetailsForm.controls['accept_export_order'].setValue(this.companyDetails.accept_export_order)
          this.companyDetailsForm.controls['last_year_revenue'].setValue(this.companyDetails.last_year_revenue)
          this.companyDetailsForm.controls['last_year_revenue_unit'].setValue(this.companyDetails.last_year_revenue_unit)
          this.companyDetailsForm.controls['export_liscense_no'].setValue(this.companyDetails.export_liscense_no)
          this.companyDetailsForm.controls['working_capital_required'].setValue(this.companyDetails.working_capital_required)
          this.companyDetailsForm.controls['gst_number'].setValue(this.companyDetails.gst_number)
          this.companyDetailsForm.controls['pan_number'].setValue(this.companyDetails.pan_number)
          this.companyDetailsForm.controls['is_gst_registered'].setValue(this.companyDetails.is_gst_registered)
          this.companyDetailsForm.controls['current_year_revenue'].setValue(this.companyDetails.current_year_revenue)
          this.companyDetailsForm.controls['last_to_last_year_revenue'].setValue(this.companyDetails.last_to_last_year_revenue)
          this.companyDetailsForm.controls['current_year_revenue_unit'].setValue(this.companyDetails.current_year_revenue_unit)
          this.companyDetailsForm.controls['last_to_last_year_revenue_unit'].setValue(this.companyDetails.last_to_last_year_revenue_unit)
          this.companyDetailsForm.controls['owner_involvement'].setValue(this.companyDetails.owner_involvement)
          this.companyDetailsForm.controls['proprietor_email'].setValue(this.companyDetails.proprietor_email)

          let countryCode = this.companyDetails.proprietor_contact_no.substring(0, (this.companyDetails.proprietor_contact_no.length - 10));
          this.companyDetailsForm.controls['proprietor_phone_country_code'].setValue(countryCode);
          this.companyDetailsForm.controls['proprietor_phone'].setValue(this.companyDetails.proprietor_contact_no.replace(countryCode, ''));

          if (this.companyDetails.accept_export_order) {
            this.showExportLiscense = true;
          }

          if (this.companyDetails.working_capital_required) {
            this.showAllTurnOver = true;
          }
        } else {
          this.companyDetailsForm.controls['working_capital_required'].setValue(false);
        }

        if (primaryContactPerson) {
          this.companyDetailsForm.controls['contact_person_title'].setValue(primaryContactPerson.title);
          this.companyDetailsForm.controls['contact_person_name'].setValue(primaryContactPerson.name);
          this.companyDetailsForm.controls['contact_person_email'].setValue(primaryContactPerson.email);
          // let countryCode = primaryContactPerson.contact_number.substring(0, (primaryContactPerson.contact_number.length - 10));
          let countryCode = primaryContactPerson.country_code;
          this.companyDetailsForm.controls.contact_person_country_code.setValue(countryCode);
          this.companyDetailsForm.controls.contact_person_phone.setValue(primaryContactPerson.contact_number.replace(countryCode, ''));
        }

        this.loaderService.display(false);

      }, err => {

        this.loaderService.display(false);
        if (err.error) {
          for (let i in err.error.errors) {
            this.toastr.error(err.error.errors[i]);
          }
        }
      }
    );
  }

  addFactoryAddress() {
    (this.companyDetailsForm.get('address_attributes') as FormArray).push(this.fb.group({
      pin_code: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 -]*$")]],
      address: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ,.-]*$")]],
      city: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      state: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      country: ["", [Validators.required, Validators.pattern("^[A-Za-z ]*$")]],
      address_type: ["factory", Validators.required],
      property_type: ""
    }));
  }

  removeFactoryAddress(idx) {
    if (idx == 1) {
      return this.toastr.error('Atleast 1 Factory address is mandatory', 'Error');
    }
    else {
      if (idx) {
        (this.companyDetailsForm.get('address_attributes') as FormArray).removeAt(idx);

      }
      let address_type = []
      let address_array = this.companyDetailsForm.get('address_attributes').value
      address_array.forEach(element => {
        address_type.push(element.address_type)
      });

      if (address_type[address_type.length - 1] != "factory") {
        return this.toastr.error('Please add atleast 1 factory address', 'Error');
      }
    }


  }

  setValueAddress(item) {
    if (item == null || item == undefined || item.address_type == null || item.address_type == undefined) return;
    (this.companyDetailsForm.get('address_attributes') as FormArray).push(this.fb.group({
      pin_code: [item.pin_code, [Validators.required, Validators.pattern("^[A-Za-z0-9 -]*$")]],
      address: [item.address, [Validators.required, Validators.pattern("^[A-Za-z0-9 ,.-]*$")]],
      city: [item.city, [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      state: [item.state, [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      country: [item.country, [Validators.required, Validators.pattern("^[A-Za-z ]*$")]],
      address_type: [item.address_type, Validators.required],
      property_type: item.property_type
    }));
  }

  initializePrimaryAddress() {
    (this.companyDetailsForm.get('address_attributes') as FormArray).push(this.fb.group({
      pin_code: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 -]*$")]],
      address: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ,.-]*$")]],
      city: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      state: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      country: ["", [Validators.required, Validators.pattern("^[A-Za-z ]*$")]],
      address_type: ["primary", Validators.required],
      property_type: ""
    }));
  }

  initializeFactoryAddress() {
    (this.companyDetailsForm.get('address_attributes') as FormArray).push(this.fb.group({
      pin_code: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 -]*$")]],
      address: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ,.-]*$")]],
      city: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      state: ["", [Validators.required, Validators.pattern("^[A-Za-z0-9 ]*$")]],
      country: ["", [Validators.required, Validators.pattern("^[A-Za-z ]*$")]],
      address_type: ["factory", Validators.required],
      property_type: "owned"
    }));
  }

  isPrimaryAddress(item) {
    return item.controls.address_type.value == "primary"
  }

  checkAcceptExportOrder(args) {
    if (args) {
      this.showExportLiscense = true;
    } else {
      this.showExportLiscense = false;
      this.companyDetailsForm.controls['export_liscense_no'].setValue(null);
    }
  }

  checkWorkingCapitalRequired(args) {
    if (args) {
      this.showAllTurnOver = true;
    } else {
      this.showAllTurnOver = false;
      this.companyDetailsForm.controls['last_to_last_year_revenue'].setValue(this.companyDetails.last_to_last_year_revenue);
      this.companyDetailsForm.controls['last_to_last_year_revenue_unit'].setValue(this.companyDetails.last_to_last_year_revenue_unit);
      this.companyDetailsForm.controls['current_year_revenue'].setValue(this.companyDetails.current_year_revenue);
      this.companyDetailsForm.controls['current_year_revenue_unit'].setValue(this.companyDetails.current_year_revenue_unit);
    }
  }



  sendOtp() {
    console.log(this.companyDetailsForm.get('contact_person_country_code').value)
    if (this.companyDetailsForm.get('contact_person_country_code').value == '') {
      return this.toastr.info('Please select country code to get OTP', 'info');
    }
    else {
      if (this.companyDetailsForm.get('contact_person_country_code').value == '+91' || this.companyDetailsForm.get('contact_person_country_code').value == '91') {
        if (this.has_verified_phone) {
          return this.toastr.info('Your mobile number is verified with us', 'info');
        }
        else {
          if (this.companyDetailsForm.get('contact_person_phone').value == '' || this.companyDetailsForm.get('contact_person_phone').value.length != 10) {
            return this.toastr.info('Please enter 10 digit mobile number to get verified', 'info');
          }
          else {
            this.onboardingService.sendOTP({ contact_no: this.companyDetailsForm.value.contact_person_phone }).subscribe(
              res => {
                this.verifyMobileForm.controls['contact_no'].setValue(this.companyDetailsForm.value.contact_person_phone);
                this.loaderService.display(false);
                // otp dialog
                const dialogRef = this.dialog.open(SubmitOtpComponent, {
                  panelClass: 'my-panel',
                  disableClose: true,
                  data: { data: this.verifyMobileForm.value }
                });
                dialogRef.afterClosed().subscribe(
                  (res: any) => {
                    if (res.data.success == true) {
                      this.showSendOtpBtn = false;
                      this.isMobileVerified = true;
                    }
                  }
                );

              }, err => {
                this.toastr.error(err.error.error);
                this.loaderService.display(false);
              }
            );
          }
        }
      }
      else {
        return this.toastr.info('OTP can be sent only with Indian code', 'info')
      }
    }

  }

  ownerBusiness(event) {
    this.ownerInvolvement = event.value;
    console.log(this.ownerInvolvement)
    if (this.ownerInvolvement != null) {
      this.companyDetailsForm.controls['owner_involvement'].setValue(this.ownerInvolvement)
    }
  }



  allowedFiles = ['pdf','docs','xls','pptx','jpeg','png','docx','jpg'];
  // portfolio related functions
  onPortFolioSelect(event) {
    if (event.target.files[0].size < 10940000) {
      if (event.target.files.length > 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          let extension = event.target.files[i]['name'].split('.');
          extension = extension[extension.length - 1].toLowerCase();
          if (this.allowedFiles.indexOf(extension) == -1) {
            return this.toastr.error('Please upload only allowed files.', 'Error');
          }
        }
        this.companyDetailsForm.get('portfolio').setValue(event.target.files);
        this.toastr.success('Your portfolio file is uploaded', 'Success');
      }
    }
    else {
      return this.toastr.error('Please upload file less than 10 mb', 'Error');
    }

  }

  downloadPortfolioBlob() {
    var blob = this.companyDetailsForm.get('portfolio').value
    var url = window.URL.createObjectURL(blob[0])
    window.open(url)
  }

  removePortfolio(portfolioId) {
    this.loaderService.display(true);
    this.onboardingService.removePortfolio(portfolioId).subscribe(
      res => {
        this.portfolioList = res;
        this.loaderService.display(false);
        this.companyDetailsForm.get('portfolio').setValue([])
        this.setCompanyDetailsForm()
        this.toastr.success('Your portfolio file is deleted please upload another', 'success');
        this.resetUploader();
      },
      err => {
        this.loaderService.display(false);
        for (let i in err.error.errors) {
          this.toastr.error(err.error.errors[i]);
        }
      }
    );
  }


  removePortfolioUploaded(index) {
    let portfolio_uploaded_array = []
    portfolio_uploaded_array.push(this.companyDetailsForm.get('portfolio').value[index])
    portfolio_uploaded_array.splice(index, 1)
    this.companyDetailsForm.controls['portfolio'].setValue(portfolio_uploaded_array)
    this.companyDetailsForm.get('portfolio').reset()
    this.toastr.info('Please note your file has been removed', 'info');
    this.resetUploader();
  }

  resetUploader() {
    (<HTMLInputElement>document.getElementById('portfolioUploader')).value = "";
  }

  downloadPortfolio(item) {
    window.open(item.attachment_file.url, "blank")
    this.toastr.success('Your portfolio File is downloaded successfully', 'Success');
  }


  get f() { return this.companyDetailsForm.controls; }
  get g() { return this.companyDetailsForm.controls.address_attributes.controls; }

  submitCompanyDetails() {
    let formData = new FormData();

    this.submitted = true;
    if (this.companyDetailsForm.invalid) {
      console.log(this.companyDetailsForm.value)
      this.toastr.error('Please fill all the fields as given in example', 'Error');
      return this.companyDetailsForm.markAllAsTouched();
    }
    if (this.companyDetailsForm.get('company_name').value.trim().length == 0) {
      return this.toastr.error('Company name not allowed space only', 'Error');
    }

    this.loaderService.display(true);
    formData.append('company_name', this.companyDetailsForm.get('company_name').value.trim());
    formData.append('website_url', this.companyDetailsForm.get('website_url').value);
    formData.append('no_of_employees', this.companyDetailsForm.get('no_of_employees').value);
    formData.append('industry_type', this.companyDetailsForm.get('industry_type').value);
    formData.append('established_in_year', this.companyDetailsForm.get('established_in_year').value);
    formData.append('proprietor_title', this.companyDetailsForm.get('proprietor_title').value);
    formData.append('proprietor_first_name', this.companyDetailsForm.get('proprietor_first_name').value);
    //formData.append('proprietor_last_name', this.companyDetailsForm.get('proprietor_last_name').value);
    formData.append('proprietor_email', this.companyDetailsForm.get('proprietor_email').value);
    formData.append('contact_person_phone', this.companyDetailsForm.get('contact_person_phone').value);
    // formData.append('phone_country_code', this.companyDetailsForm.get('phone_country_code').value);
    formData.append('contact_person_name', this.companyDetailsForm.get('contact_person_name').value);
    formData.append('contact_person_email', this.companyDetailsForm.get('contact_person_email').value);
    formData.append('accept_batch_order', this.companyDetailsForm.get('accept_batch_order').value);
    formData.append('accept_export_order', this.companyDetailsForm.get('accept_export_order').value);
    formData.append('last_year_revenue', this.companyDetailsForm.get('last_year_revenue').value);
    formData.append('last_year_revenue_unit', this.companyDetailsForm.get('last_year_revenue_unit').value);
    formData.append('working_capital_required', this.companyDetailsForm.get('working_capital_required').value);
    formData.append('gst_number', this.companyDetailsForm.get('gst_number').value);
    formData.append('pan_number', this.companyDetailsForm.get('pan_number').value);
    formData.append('is_gst_registered', this.companyDetailsForm.get('is_gst_registered').value);
    formData.append('current_year_revenue', this.companyDetailsForm.get('current_year_revenue').value);
    formData.append('last_to_last_year_revenue', this.companyDetailsForm.get('last_to_last_year_revenue').value);
    formData.append('current_year_revenue_unit', this.companyDetailsForm.get('current_year_revenue_unit').value);
    formData.append('last_to_last_year_revenue_unit', this.companyDetailsForm.get('last_to_last_year_revenue_unit').value);
    formData.append('export_liscense_no', this.companyDetailsForm.get('export_liscense_no').value);
    formData.append('owner_involvement', this.companyDetailsForm.get('owner_involvement').value);
    // formData.append('proprietor_phone_country_code', this.companyDetailsForm.get('proprietor_phone_country_code').value)
    // formData.append('proprietor_phone', this.companyDetailsForm.get('proprietor_phone').value)
    formData.append('proprietor_contact_no', this.companyDetailsForm.get('proprietor_phone_country_code').value + this.companyDetailsForm.get('proprietor_phone').value)
    formData.append('contact_person_title', this.companyDetailsForm.get('contact_person_title').value)
    // formData.append('contact_person_phone', this.companyDetailsForm.get('contact_person_phone').value)
    // formData.append('contact_person_country_code', this.companyDetailsForm.get('contact_person_country_code').value)
    formData.append('contact_contact_number', this.companyDetailsForm.get('contact_person_country_code').value + this.companyDetailsForm.get('contact_person_phone').value)

    if (this.companyDetailsForm.get('portfolio').value) {
      for (var img of this.companyDetailsForm.get('portfolio').value) {
        formData.append('portfolios[][attachment_file]', img)
      }
    }

    if (this.companyDetailsForm.get('working_capital_required').value == true) {
      if (this.companyDetailsForm.get('current_year_revenue').value == '' || this.companyDetailsForm.get('current_year_revenue').value == 0) {
        this.loaderService.display(false)
        return this.toastr.error('Current year turnover is required with unit', 'Error')
      }
      else if (this.companyDetailsForm.get('last_year_revenue').value = '' || this.companyDetailsForm.get('last_year_revenue').value == 0) {
        this.loaderService.display(false)
        return this.toastr.error('Last year revenue is required with unit', 'Error');
      }
      else if (this.companyDetailsForm.get('last_to_last_year_revenue').value == '' || this.companyDetailsForm.get('last_to_last_year_revenue').value == 0) {
        this.loaderService.display(false)
        return this.toastr.error('Last to Last year revenue is required with unit', 'Error');
      }
    }

    if (this.companyDetailsForm.get('accept_export_order').value == true) {
      if (this.companyDetailsForm.get('export_liscense_no').value == '' || this.companyDetailsForm.get('export_liscense_no').value == 0) {
        this.loaderService.display(false)
        return this.toastr.error('Import Export license number is required', 'Error');
      }
    }

    // if (this.companyDetails.get('owner_involvement').value == '') {
    //   return this.toastr.error('Owner involvement is needed in the organisation', 'Error');
    // }


    // setup the machine data
    if (this.companyDetailsForm.get('address_attributes').value.length == 0) {
      this.toastr.error('Please add one address.', 'Error');
      this.loaderService.display(false);
      return;
    }
    for (var ele of this.companyDetailsForm.get('address_attributes').value) {
      formData.append('address_attributes[][pin_code]', ele.pin_code)
      formData.append('address_attributes[][address]', ele.address)
      formData.append('address_attributes[][city]', ele.city)
      formData.append('address_attributes[][state]', ele.state)
      formData.append('address_attributes[][country]', ele.country)
      formData.append('address_attributes[][address_type]', ele.address_type)
      formData.append('address_attributes[][property_type]', ele.property_type)
    }
    this.isMobileVerified = true;
    if (this.isMobileVerified) {

      this.onboardingService.postCompanyDetails(formData).subscribe(
        res => {
          this.toastr.success("Company Details saved successfully!");
          this.loaderService.display(false);
          this.router.navigate(['./onboarding/machine-details']);
        }, err => {
          this.loaderService.display(false);
          if (err.error.message == "Validation failed:  Property type invalid property type!") {
            this.toastr.error('Property type is not valid, please select a valid property type', 'Error')
          }
          else if (err.error.message) {
            this.toastr.error(err.error.message, 'Error');
          }
          else if (err.error.error) {
            this.toastr.error(err.error.error, 'Error');
          }
          else {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i]);
            }
          }
        }
      );

    }
    else {
      this.loaderService.display(false);
      this.toastr.error('Please verify your mobile to proceed further', 'Error');
    }
  }


  saveCompanyDraft() {
    if (this.form_status) {
      return this.toastr.info('You have successfully filled all the details please click continue')
    }
    else {
      let saved_address = []
      console.log(this.companyDetailsForm.value)
      for (var ele of this.companyDetailsForm.get('address_attributes').value) {
        saved_address.push(ele)
      }


      let save_company_object = {
        "company_name": this.companyDetailsForm.get('company_name').value.trim(),
        "website_url": this.companyDetailsForm.get('website_url').value,
        "industry_type": this.companyDetailsForm.get('industry_type').value,
        "established_in_year": this.companyDetailsForm.get('established_in_year').value,
        "proprietor_title": this.companyDetailsForm.get('proprietor_title').value,
        "proprietor_first_name": this.companyDetailsForm.get('proprietor_first_name').value,
        "proprietor_last_name": "",
        "proprietor_email": this.companyDetailsForm.get('proprietor_email').value,
        "contact_person_phone": this.companyDetailsForm.get('contact_person_phone').value,
        "contact_person_name": this.companyDetailsForm.get('contact_person_name').value,
        "contact_person_email": this.companyDetailsForm.get('contact_person_email').value,
        "no_of_employees": this.companyDetailsForm.get('no_of_employees').value,
        "accept_batch_order": this.companyDetailsForm.get('accept_batch_order').value,
        "accept_export_order": this.companyDetailsForm.get('accept_export_order').value,
        "last_year_revenue": this.companyDetailsForm.get('last_year_revenue').value,
        "last_year_revenue_unit": this.companyDetailsForm.get('last_year_revenue_unit').value,
        "current_year_revenue_unit": this.companyDetailsForm.get('current_year_revenue_unit').value,
        "last_to_last_year_revenue_unit": "INR",
        "working_capital_required": this.companyDetailsForm.get('working_capital_required').value,
        "gst_number": this.companyDetailsForm.get('gst_number').value,
        "pan_number": this.companyDetailsForm.get('pan_number').value,
        "is_gst_registered": this.companyDetailsForm.get('is_gst_registered').value,
        "current_year_revenue": this.companyDetailsForm.get('current_year_revenue').value,
        "owner_involvement": this.companyDetailsForm.get('owner_involvement').value,
        "last_to_last_year_revenue": this.companyDetailsForm.get('last_to_last_year_revenue').value,
        "export_liscense_no": this.companyDetailsForm.get('export_liscense_no').value,
        "address_attributes": saved_address,
        "portfolio_attachments": [this.companyDetailsForm.get('portfolio').value],
        "contact_person_country_code": this.companyDetailsForm.get('contact_person_country_code').value,
        "proprietor_phone": this.companyDetailsForm.get('proprietor_phone').value,
        "proprietor_phone_country_code": this.companyDetailsForm.get('proprietor_phone_country_code').value,
        "contact_person_title": this.companyDetailsForm.get('contact_person_title').value

      }


      this.onboardingService.postCompanyDetails(save_company_object).subscribe(
        res => {
          this.toastr.success("Your Company Details saved successfully!", 'Success');
          this.loaderService.display(false);
          // this.setCompanyDetailsForm();
        }, err => {
          this.loaderService.display(false);
          if (err.error.message) {
            this.toastr.error(err.error.message);
          } else if (err.error.error) {
            this.toastr.error(err.error.error);
          } else {
            for (let i in err.error.errors) {
              this.toastr.error(err.error.errors[i]);
            }
          }
        }
      );
    }
  }

  // saveCompanyDetails() {
  //   let formData = new FormData();
  //   this.submitted = false;
  //   formData.append('company_name', this.companyDetailsForm.get('company_name').value);
  //   formData.append('website_url', this.companyDetailsForm.get('website_url').value);
  //   formData.append('no_of_employees', this.companyDetailsForm.get('no_of_employees').value);
  //   formData.append('industry_type', this.companyDetailsForm.get('industry_type').value);
  //   formData.append('established_in_year', this.companyDetailsForm.get('established_in_year').value);
  //   formData.append('proprietor_title', this.companyDetailsForm.get('proprietor_title').value);
  //   formData.append('proprietor_first_name', this.companyDetailsForm.get('proprietor_first_name').value);
  //   formData.append('proprietor_last_name', this.companyDetailsForm.get('proprietor_last_name').value);
  //   formData.append('proprietor_email', this.companyDetailsForm.get('proprietor_email').value);
  //   formData.append('contact_person_phone', this.companyDetailsForm.get('contact_person_phone').value);
  //   // formData.append('phone_country_code', this.companyDetailsForm.get('phone_country_code').value);
  //   formData.append('contact_person_name', this.companyDetailsForm.get('contact_person_name').value);
  //   formData.append('contact_person_email', this.companyDetailsForm.get('contact_person_email').value);
  //   formData.append('accept_batch_order', this.companyDetailsForm.get('accept_batch_order').value);
  //   formData.append('accept_export_order', this.companyDetailsForm.get('accept_export_order').value);
  //   formData.append('last_year_revenue', this.companyDetailsForm.get('last_year_revenue').value);
  //   formData.append('last_year_revenue_unit', this.companyDetailsForm.get('last_year_revenue_unit').value);
  //   formData.append('working_capital_required', this.companyDetailsForm.get('working_capital_required').value);
  //   formData.append('gst_number', this.companyDetailsForm.get('gst_number').value);
  //   formData.append('pan_number', this.companyDetailsForm.get('pan_number').value);
  //   formData.append('is_gst_registered', this.companyDetailsForm.get('is_gst_registered').value);
  //   formData.append('current_year_revenue', this.companyDetailsForm.get('current_year_revenue').value);
  //   formData.append('last_to_last_year_revenue', this.companyDetailsForm.get('last_to_last_year_revenue').value);
  //   formData.append('current_year_revenue_unit', this.companyDetailsForm.get('current_year_revenue_unit').value);
  //   formData.append('last_to_last_year_revenue_unit', this.companyDetailsForm.get('last_to_last_year_revenue_unit').value);
  //   formData.append('export_liscense_no', this.companyDetailsForm.get('export_liscense_no').value);
  //   formData.append('', this.companyDetailsForm.get('portfolio').value);
  //   formData.append('owner_involvement', this.companyDetailsForm.get('owner_involvement').value);

  //   if (this.companyDetailsForm.get('portfolio').value) {
  //     for (var img of this.companyDetailsForm.get('portfolio').value) {
  //       formData.append('portfolios[][attachment_file]', img)
  //     }
  //   }


  //   // setup the machine data
  //   for (var ele of this.companyDetailsForm.get('address_attributes').value) {
  //     formData.append('address_attributes[][pin_code]', ele.pin_code)
  //     formData.append('address_attributes[][address]', ele.address)
  //     formData.append('address_attributes[][city]', ele.city)
  //     formData.append('address_attributes[][state]', ele.state)
  //     formData.append('address_attributes[][country]', ele.country)
  //     formData.append('address_attributes[][address_type]', ele.address_type)
  //     formData.append('address_attributes[][property_type]', ele.property_type)
  //   }

  //   if (this.isMobileVerified) {
  //     this.onboardingService.postCompanyDetails(formData).subscribe(
  //       res => {
  //         this.toastr.success("Company Details saved successfully!");
  //         this.loaderService.display(false);
  //         this.router.navigate(['./onboarding/machine-details']);
  //       }, err => {
  //         this.loaderService.display(false);
  //         console.log(err);
  //         if (err.error.message) {
  //           this.toastr.error(err.error.message);
  //         } else if (err.error.error) {
  //           this.toastr.error(err.error.error);
  //         } else {
  //           for (let i in err.error.errors) {
  //             this.toastr.error(err.error.errors[i]);
  //           }
  //         }
  //       }
  //     );
  //   }
  //   else {
  //     this.toastr.error('Please Verify your number', 'Error')
  //   }
  // }

  // unused functions

  // matchPhoneNumber() {
  //   var country_code = this.companyDetailsForm.controls['phone_country_code'].value
  //   var mobile_number = this.companyDetailsForm.controls['contact_person_phone'].value

  //   if (country_code == "91") {
  //     if (this.phoneNumber == mobile_number) {
  //       this.showSendOtpBtn = false;
  //       this.isMobileVerified = true;
  //     } else {
  //       this.showSendOtpBtn = true;
  //       this.isMobileVerified = false;
  //     }
  //   }
  // }

  // submitOtp() {
  //   this.loaderService.display(true);
  //   this.onboardingService.submitOTP(this.verifyMobileForm.value).subscribe(
  //     res => {
  //       this.showSendOtpBtn = false;
  //       this.isMobileVerified = true;
  //       this.phoneNumber = this.verifyMobileForm.value.contact_no;
  //       this.loaderService.display(false);
  //     }, err => {
  //       this.toastr.error(err.error.error);
  //       this.loaderService.display(false);
  //     }
  //   )
  // }

}
